import { defaultFilterState, filterNames } from '../constants/common';
import {
  SET_SEARCH,
  SET_FILTER_VISIBLE,
  SET_PERIOD,
  SET_TYPES,
  SET_COMPANIES,
  SET_STREETS,
  SET_HOUSES,
  SET_ADDRESSES,
  SET_ONLY_ACTIVE,
  RESET_FILTER_STATE,
  SET_SELECTED_INFO,
  SET_EDITOR_STATE,
  SET_EDITOR_LINK_MODAL_DATA,
  SET_EDITOR_PHONE_MODAL_DATA,
} from './actionsTypes';
import { decorators, initEditorLinkModalData, initEditorPhoneModalData } from '../../../components/MessageEditor';
import { EditorState } from 'draft-js';

const defaultEditorState = EditorState.createEmpty(decorators);

const initialState = {
  search: '',
  filterVisible: false,
  selectedInfo: null,
  editorPhoneModalData: initEditorPhoneModalData,
  editorLinkModalData: initEditorLinkModalData,
  editorState: defaultEditorState,
  ...defaultFilterState,
};

const newInformationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SEARCH:
      return {
        ...state,
        search: payload,
      };
    case SET_EDITOR_STATE:
      return {
        ...state,
        editorState: payload,
      }
    case SET_EDITOR_LINK_MODAL_DATA:
      return {
        ...state,
        editorLinkModalData: payload,
      };
    case SET_EDITOR_PHONE_MODAL_DATA:
      return {
        ...state,
        editorPhoneModalData: payload,
      };
    case SET_FILTER_VISIBLE:
      return {
        ...state,
        filterVisible: payload,
      };
    case SET_PERIOD:
      return {
        ...state,
        [filterNames.period]: payload,
      };
    case SET_TYPES:
      return {
        ...state,
        [filterNames.types]: payload,
      };
    case SET_COMPANIES:
      return {
        ...state,
        [filterNames.companies]: payload,
      };
    case SET_STREETS: {
      const { streets, houses, addresses } = filterNames;
      const newState = {
        ...state,
        [streets]: payload,
      };

      if (state[streets][0] !== payload[0]) {
        newState[houses] = defaultFilterState[houses];
        newState[addresses] = defaultFilterState[addresses];
      }

      return newState;
    }
    case SET_HOUSES: {
      const newState = {
        ...state,
        [filterNames.houses]: payload,
      };

      if (state[filterNames.houses][0] !== payload[0]) {
        newState[filterNames.addresses] =
          defaultFilterState[filterNames.addresses];
      }

      return newState;
    }
    case SET_ADDRESSES:
      return {
        ...state,
        [filterNames.addresses]: payload,
      };
    case SET_ONLY_ACTIVE:
      return {
        ...state,
        [filterNames.onlyActive]: payload,
      };
    case RESET_FILTER_STATE:
      return {
        ...state,
        ...defaultFilterState,
      };
    case SET_SELECTED_INFO:
      return {
        ...state,
        selectedInfo: payload,
      };
    default:
      return state;
  }
};

export default newInformationsReducer;
